<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><path fill="none" d="M16,37.554 C7.984,35.735,2,28.566,2,20c0-9.941,8.059-18,18-18c8.566,0,15.735,5.984,17.554,14"></path> <path fill="none" d=" M15.003,28.664C12.012,26.935,10,23.703,10,20c0-5.523,4.477-10,10-10c3.703,0,6.935,2.012,8.664,5.003"></path> <polygon fill="none" points="20,20 23,42 29,36 38,45 45,38 36,29 42,23 " :stroke="fill"></polygon></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>